<template>
  <label class="p-radio">
    <input
      :id="name"
      :v-model="modelValue"
      :checked="isChecked"
      v-bind="{ ...$attrs, ...(inputAttributes as InputHTMLAttributes) }"
      :data-test="testAttribute"
      :class="['p-radio__field', `p-radio__field--${size}`]"
      type="radio"
      @change="onChange"
    />
    <span v-if="label" class="p-radio__text" v-text="label" />
  </label>
</template>

<script setup lang="ts">
import type { InputHTMLAttributes } from 'vue'

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  radioValue: {
    type: [Boolean],
    default: null,
  },
  label: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: 'md',
    validator: (val: string) => ['sm', 'md'].includes(val),
  },
})

const testAttribute = dataTest(`${props.radioValue}-${props.name}`)

const modelValue = defineModel<Boolean>('modelValue')

const inputAttributes = {
  name: props.name,
  disabled: props.disabled,
}

const isChecked = computed<Boolean>(() => modelValue.value === props.radioValue)

const onChange = () => {
  modelValue.value = props.radioValue
}
</script>
